export default __webpack_public_path__ + "static/media/pizza-640w.c3c770a7.jpg";